import { createSlice } from '@reduxjs/toolkit';

import { Service, ServiceCategory } from 'ux/Tenant/Services/types';

const initialState: ServicesState = {
  searchQuery: '',
  filteredCategories: null,
  filteredServices: null
};

export type ServicesState = {
  searchQuery: string;
  filteredCategories: ServiceCategory[] | null;
  filteredServices: Service[] | null;
};

const servicesSlice = createSlice({
  name: 'Services',
  initialState,
  reducers: {
    setSearchQuery: (state, action) => {
      state.searchQuery = action.payload;
    },
    setFilteredCategories: (state, action) => {
      state.filteredCategories = action.payload;
    },
    setFilteredServices: (state, action) => {
      state.filteredServices = action.payload;
    }
  }
});

export const { actions } = servicesSlice;

export default servicesSlice.reducer;
